type OrgFeatureFlags = {
  vira_scribe?: boolean | null
  vira_loop?: boolean | null
}

/**
 * Effective scribe gate for transcript / care-plan UI.
 * Loop Pro (`vira_loop`) implies scribe; scribe alone remains for legacy surfaces.
 * Does not affect `ai_services_org_members`.
 */
export function isEffectiveViraScribeEnabled({
  forceViraScribe: forceScribe = false,
  forceViraLoop: forceLoop = false,
  organizationFeatures,
}: {
  forceViraScribe?: boolean
  forceViraLoop?: boolean
  organizationFeatures?: OrgFeatureFlags[] | null
}): boolean {
  const hasScribe =
    organizationFeatures?.some((feature) => feature.vira_scribe === true) ??
    false
  const hasLoop =
    organizationFeatures?.some((feature) => feature.vira_loop === true) ?? false
  return forceScribe || forceLoop || hasScribe || hasLoop
}
